import PaginationNew from './pagination-new'

export default PaginationNew
